import { render, staticRenderFns } from "./PassengerInformations.vue?vue&type=template&id=6542d1bb&scoped=true"
import script from "./PassengerInformations.vue?vue&type=script&lang=js"
export * from "./PassengerInformations.vue?vue&type=script&lang=js"
import style0 from "./PassengerInformations.vue?vue&type=style&index=0&id=6542d1bb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6542d1bb",
  null
  
)

export default component.exports